<template>
  <v-card>
    <v-card-title style="background-color: rgb(8, 71, 118)">
      <span style="color: white" v-if="!inEdit" class="headline"
        >Nova baza izdanja</span
      >
      <span style="color: white" v-else class="headline"
        >Uređivanje baze izdanja</span
      >
      <v-spacer></v-spacer>
      <v-icon @click="close" color="white">mdi-close</v-icon>
    </v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-container>
          <v-row class="mt-8">
            <v-col cols="12">
              <v-text-field
                v-model="nazivBaza"
                label="Unesi naziv baze izdanja*"
                required
                outlined
                dense
                :rules="[rules.nameRules]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <hint v-if="!inEdit" :hints="getBazaHints" :isSelectable="isSelectable" v-on:selectItem="selectBazu"></hint>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!isValid"
        color="rgb(8, 71, 118)"
        style="color: white"
        class="mr-7 mb-2 mt-n7"
        :loading="$wait.is('getBazaIzdanjaHint')"
        @click="save"
        >Spremi</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
 
<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";
export default {
  props: ["inEdit", "selectedEdition", "naziv", "isSelectable"],
  computed: {
    ...mapGetters(["getBazaHints"]),
    isValid() {
      return this.nazivBaza != "" && this.nazivBaza;
    },
    nazivBaza: {
      set(value) {
        if (value) {
          let self = this;
          this.getHint(self, value);
          this.$emit("setNaziv", value);
        } else {
          this.$emit("setNaziv", null);
        }
      },
      get() {
        return this.naziv;
      },
    },
  },
  data() {
    return {
      rules: {
        nameRules: (v) => !!v || "Naziv baze izdanja je obavezan!",
      },
    };
  },
  mounted(){
    // this.$refs.form.reset();
  },
  methods: {
    selectBazu(item){
      if(this.isSelectable){
        this.$emit("setSaved", item);
        this.$emit("setNaziv", "");
        this.$refs.form.reset();
      }
    },
    getHint: _.debounce((self, value) => {
      waitFor("getBazaIzdanjaHint", async function () {
        await self.$store.dispatch("getBazaIzdanjaHint", {
          page: 1,
          search: value,
        });
      }).apply(self);
    }, 500),
    async save() {
      if (this.inEdit) {
        this.$store
          .dispatch("editNewDatabaseEdition", {
            id: this.selectedEdition.id,
            naziv: this.naziv,
          })
          .then(() => {
            this.$store.commit('SET_BAZA_HINTS', null)
            this.close();
          });
      } else {
        this.$store
          .dispatch("createAllNewDatabaseEdition", this.naziv)
          .then((res) => {
            if (res) {
              this.$emit("setSaved", res);
              this.$store.commit('SET_BAZA_HINTS', null)
              
            }
            this.close();
          });
      }
      // this.$refs.form.reset();
    },
    close() {
      this.$emit("setNaziv", '');
      this.$store.commit('SET_BAZA_HINTS', null)
      this.$emit("closeDialog");
      this.$refs.form.reset();
    },
  },
};
</script>